import React, { useState, useEffect } from "react";
import Timer from "./TheTimer";
import GUIset_Single from "./gui/GUIset_Single";
import Template from "./TheTemplate";

//from Freq
const Fibonacci = () => {
	useEffect(() => {
		document.title = "Fibonacci Numbers";
	}, []);
	const [guiTxt1, guiTxtChange1] = useState("32");
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result
	//-----------------------------------
	const buttonClick1 = () => {
		if (guiTxt1 != "") {
			target = parseInt(guiTxt1);
			Timer.start();
			process();
			txt_time = Timer.stop_print();
			Timer.start();
			process2();
			txt_time2 = Timer.stop_print();
			process3();//print detail only
			BuildResult();
			memory = [];
		}
	};

	var target = 0;
	var txt_time = "";
	var txt_time2 = "";
	var sum1 = 0;
	var nth1 = 0;
	var limitRecursion = 10000;
	// var sum2 = 0;
	// var nth2 = 0;
	var txt1 = "";
	var memory = [];

	function process() {
		if (target <= 1) {
			sum1 = 1;
		} else if (target > 1) {
			var n_2 = 1,
				n_1 = 1; //most recent , x - 1
			for (var i = 1; i < target - 1; i++) {
				var temp = n_1;
				n_1 = n_2;
				n_2 += temp;
				nth1 = n_1;
			}
			sum1 = n_2;
		}
		// console.log("done ");
	}

	function process2() {
		memory = Array(target + 1).fill(0);
		if (target > limitRecursion) {
			fibo(limitRecursion);
		} else {
			fibo(target);
		}
	}

	function fibo(n) {
		if (n < 2) {
			return n;
		} else {
			var v = memory[n];
			if (v < 1) {
				// console.log("FIND " + n);
				v = fibo(n - 1) + fibo(n - 2);
				memory[n] = v;
			}
			// else { console.log("FOUND " + n); }
			return v;
		}
	}

	//print only
	function process3() {
		txt1 = "0th : 0\n";
		if (target > 0) {
			txt1 += "1th : 1\n";
			var n_2 = 1,//n - 2
				n_1 = 1; //n - 1, most recent
			for (var i = 1; i < target; i++) {
				var temp = n_1;
				n_1 = n_2;
				n_2 += temp;
				if (i < 1500)  txt1 += i + 1 + "th : " + n_1 + "\n";
				else if (i == 1500) txt1 += "..."; 
			}
		}
		// console.log("done ");
	}

	//-------------------------

	function BuildResult() {
		var txt = "";
		var txt2 = "";
		txt += target + "th\t\t: " + nth1 + "\n";
		txt += "Sum \t\t: " + sum1 + "\n";
		txt2 += txt_time + " (iterative approach)\n";
		txt2 += txt_time2 + " (recursive approach)";
		if (target > limitRecursion) {
			txt2 +=
				"* Recursion limited at " + limitRecursion + " to prevent error\n";
		}
		// partResultChange(Template.simple01x2("Result",txt,22,"Number",txt1,20));
		var part1 = Template.simple01("key1", "Result", txt, 22, 20);
		var part2 = Template.single01("key1", txt2, 18);
		var part3 = Template.simple00("key3", 1, "Number", txt1, 22, 18);
		partResultChange(
			<div>
				{part1}
				<br />
				{part2}
				<br />
				{part3}
			</div>
		);
	}

	return (
		<GUIset_Single
			title={"The Nth and the Sum of Fibonacci Numbers"}
			desc={
				"Finding the Nth Fibonacci number and the summation from the first to the Nth, comparing recursive and iterative methods."
			}
			guiTxt={guiTxt1}
			guiTxtChange={guiTxtChange1}
			buttonClick={buttonClick1}
			partResult={partResult}
			label1={"N ="}
			isNumOnly={true}
			txtButton={"Calculate"}
		/>
	);
};

export default Fibonacci;
